import type { ReactNode } from "react";
import { Chip } from "@/components/badge/chip";
import type { TaskDue } from "./due";

// Right side of a task row, three states: already confirmed → green chip;
// current user can act → the caller's due-input + confirm button (children);
// someone else's task → due / overdue chip so the requester can chase.
export const TaskRowStatus = ({
  confirmedAt,
  canAct,
  due,
  children,
}: {
  confirmedAt?: string | null;
  canAct: boolean;
  due: TaskDue;
  children: ReactNode;
}) => {
  if (confirmedAt) return <Chip tone="green">confirmed</Chip>;
  if (canAct) return <>{children}</>;
  return (
    <Chip tone={due.overdue ? "red" : "yellow"}>
      {due.overdue ? `overdue ${due.date}` : `due ${due.date}`}
    </Chip>
  );
};
